import { render, staticRenderFns } from "./placeOrder.vue?vue&type=template&id=040e9140&scoped=true"
import script from "./placeOrder.vue?vue&type=script&lang=js"
export * from "./placeOrder.vue?vue&type=script&lang=js"
import style0 from "./placeOrder.vue?vue&type=style&index=0&id=040e9140&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040e9140",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('040e9140')) {
      api.createRecord('040e9140', component.options)
    } else {
      api.reload('040e9140', component.options)
    }
    module.hot.accept("./placeOrder.vue?vue&type=template&id=040e9140&scoped=true", function () {
      api.rerender('040e9140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/workbench/components/placeOrder.vue"
export default component.exports